import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["data-bs-target"]
const _hoisted_3 = { class: "form-check d-flex align-items-center" }
const _hoisted_4 = { class: "form-check-label NKT-P1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["id", "data-bs-parent"]
const _hoisted_7 = {
  key: 0,
  class: "list-group scrollable-list-group"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = { class: "flex-grow-1" }
const _hoisted_11 = { class: "NKT-P1" }
const _hoisted_12 = { class: "d-flex justify-content-between mt-2" }
const _hoisted_13 = { class: "mt-2" }
const _hoisted_14 = {
  key: 0,
  class: "list-group-item list-group-item-action NKT-P1"
}
const _hoisted_15 = {
  key: 1,
  class: "list-group scrollable-list-group"
}

import AlarmSources from '@/components/cells/AlarmSourcesCell.vue'
import DateTime from '@/components/cells/DateTimeCell.vue'
import KpCell from '@/components/cells/KpCell.vue'
import AlarmDescriptionCell from '@/components/cells/AlarmDescriptionCell.vue'
import CoordinateCell from '@/components/cells/CoordinateCell.vue'
import { Alarm } from '@/server/MakeSenseApp-backend'
import { ref } from 'vue'
import MsButton from '@/components/general/buttons/MsButton.vue'
import arrow from '@/assets/svg/arrow.svg'
import lock from '@/assets/svg/lock-gray.svg'


export default /*@__PURE__*/_defineComponent({
  __name: 'DropDownAlarms',
  props: {
  alarms: Array<Alarm>,
  alarmCount: Number,
  disabled: {
    type: Boolean,
    default: false
  }
},
  emits: ['alarm-click'],
  setup(__props, { emit: __emit }) {

const props = __props

const accordionInnerId = ref('accordion-filter-alarms')
const accordionOuterId = ref('dropdown-filter-alarms')

const emit = __emit

function alarmClick(alarm: Alarm) {
  if (alarm && alarm.id) {
    alarm.visited = true
    emit('alarm-click', alarm.id)
  }
}

const isExpanded = ref(false)

const toggle = () => {
  if (!props.disabled) {
    isExpanded.value = !isExpanded.value
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "accordion",
    id: accordionOuterId.value
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["accordion-item accordion-layout", { disabled: __props.disabled }])
    }, [
      _createElementVNode("a", {
        href: "#",
        class: "d-flex justify-content-between align-items-center accordion-layout-inner",
        "data-bs-toggle": "collapse",
        "data-bs-target": '#' + accordionInnerId.value,
        onClick: toggle
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, "Alarms " + _toDisplayString(__props.alarmCount ? ' (' + __props.alarmCount + ')' : '(0)'), 1)
        ]),
        _createElementVNode("div", null, [
          _createVNode(MsButton, {
            disabled: __props.disabled,
            "data-bs-toggle": "collapse",
            "data-bs-target": '#' + accordionInnerId.value,
            "aria-expanded": "false",
            "aria-controls": accordionInnerId.value
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: __props.disabled ? _unref(lock) : _unref(arrow),
                class: _normalizeClass(["icon", { rotated: isExpanded.value && !__props.disabled }])
              }, null, 10, _hoisted_5)
            ]),
            _: 1
          }, 8, ["disabled", "data-bs-target", "aria-controls"])
        ])
      ], 8, _hoisted_2),
      _createElementVNode("div", {
        id: accordionInnerId.value,
        class: "accordion-collapse collapse",
        "data-bs-parent": '#' + accordionOuterId.value
      }, [
        (__props.alarmCount)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.alarms, (alarm, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  onClick: ($event: any) => (alarmClick(alarm)),
                  href: "#",
                  class: "list-group-item list-group-item-action",
                  key: index,
                  "aria-current": "true"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(AlarmSources, {
                        alarmSources: alarm.alarmSources
                      }, null, 8, ["alarmSources"])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(DateTime, {
                        timestamp: alarm.timestamp
                      }, null, 8, ["timestamp"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(KpCell, {
                      kp: alarm.kp,
                      color: "black"
                    }, null, 8, ["kp"]),
                    _createVNode(CoordinateCell, {
                      color: "black",
                      coordinates: [alarm.coordinate?.latitude ?? 0, alarm.coordinate?.longitude ?? 0]
                    }, null, 8, ["coordinates"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(AlarmDescriptionCell, { alarm: alarm }, null, 8, ["alarm"])
                  ])
                ], 8, _hoisted_8))
              }), 128)),
              (__props.alarmCount > 20)
                ? (_openBlock(), _createElementBlock("li", _hoisted_14, " There are more alarms. Please visit the Alarm log page. "))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "list-group-item list-group-item-action NKT-P1" }, " No alarms detected at selected time. ", -1)
            ])))
      ], 8, _hoisted_6)
    ], 2)
  ], 8, _hoisted_1))
}
}

})